export const NOTIFICATIONS_PARAMS = {
  NOTIFICATION_TYPE_EMAIL: 'email',
  DOWNLOAD_APP_NOTIFICATION_NAME: 'M6_HM_Descarga_app',
  REGISTER_AND_DOWNLOAD_APP_NOTIFICATION_NAME: 'M5_HM_Registro y descarga app - Sin código',
  CONTRACT_HP_NOTIFICATION_NAME: 'M2_HM_Contrato_Honda_Plus',
}

export const getNotificationModel = (destination, type, name) => ({destination, type, name})

export const getArchivedModel = archived => ({archived})
